import React from 'react';

import SimpleMessagePage from 'components/SimpleMessagePage';
import useWorkflow, { Step } from 'hooks/useWorkflow';

import {
  useMarkdownTranslate,
  useMarkdownMultilineTranslate,
} from 'hooks/useTranslate/useTranslate';

import CancelButton from 'features/CancelButton';
import Link from 'components/Link';
import Button from 'components/Button';

const NotQualified: React.FC = () => {
  const { pathAfter } = useWorkflow();
  const tMd = useMarkdownTranslate();
  const tMdMulti = useMarkdownMultilineTranslate();

  return (
    <SimpleMessagePage
      headerTitle={'unified.application.notQualified.title'}
      message={tMdMulti('unified.application.notQualified.message')}
    >
      <Button
        id="continueToApplication"
        variant="contained"
        component={Link}
        data-cy="continueButton"
        to={pathAfter(Step.UNIFIED_OFFER_APPLICATION)}
      >
        {tMd('unified.application.notQualified.continueButton')}
      </Button>
      <CancelButton />
    </SimpleMessagePage>
  );
};

export default NotQualified;
